import React from 'react';
import { Step } from '../common/Step';
import { StepSection } from '../common/StepSection';
import { observer } from 'mobx-react';
import { FormButtonWrapper } from '../common/FormButtonWrapper';
import { Button } from '../../../commonv2/components/Button';
import { GlobalLoader } from '../../components/GlobalLoader';
import './inputStep.module.scss';
import { routingStore } from '../../../common/stores/routing';
import { V2Routes } from '../../routes';
import { CardPaymentForm } from '../common/payment/CardPaymentForm';
import { UserForm } from '../common/userInfo/UserForm';
import { ReserverType, EventReservationPageState } from './states/EventReservationPageState';
import { EventSummary } from './components/EventSummary';
import { StepText } from '../common/StepText';

type Props = {
  pageState: EventReservationPageState;
};

export const InputStep = observer(({ pageState }: Props) => {
  const { event: eventResource, userForm, appliedPrice, goToConfirmation, userEventReservationStatus } = pageState;
  if (eventResource.isEmpty()) {
    throw new Error("InputStep shouldn't be rendered before initialization complete");
  }
  const needPayment = appliedPrice > 0;
  const shouldRegisterCard =
    pageState.paymentMethodForm.useNewCard || pageState.paymentMethodForm.currentCard.isEmpty();
  if (!(needPayment && shouldRegisterCard) && !userForm.needUserInput()) {
    goToConfirmation();
  }

  const event = eventResource.get();
  return (
    <Step id="input-step">
      {pageState.reserverType === ReserverType.NEW_USER && (
        <div styleName="member-login-button">
          <Button type="secondary" onClick={() => routingStore.push(V2Routes.signInPage(location.href))}>
            既に会員の方はこちら
          </Button>
        </div>
      )}
      <StepSection title="予約情報の確認" styleName="section">
        {userEventReservationStatus !== null && (
          <EventSummary event={event} userEventReservationStatus={userEventReservationStatus} />
        )}
      </StepSection>
      {pageState.userForm.needUserInput() && (
        <StepSection title="お客様情報の入力">
          <UserForm state={pageState.userForm} />
        </StepSection>
      )}
      {needPayment && (
        <StepSection title="お支払い方法">
          <CardPaymentForm state={pageState.paymentMethodForm} priceWithoutTax={event.price} allowSplit={false} />
          {(['number', 'exp'] as const).map((value) => (
            <div styleName="error" key={value}>
              {pageState.paymentMethodForm.newCardForm.getError(value)}
            </div>
          ))}
        </StepSection>
      )}
      {event.note && (
        <StepSection title="備考">
          <StepText>{event.note}</StepText>
        </StepSection>
      )}
      {needPayment && (
        <StepSection title="キャンセルについて">
          <StepText>
            イベント開催２週間前からキャンセル料が発生するため、ご注意ください。
            <br />
            <br />
            キャンセル料に関しては以下です。
            <br />
            開催日14日前～8日前まで：参加費の50％
            <br />
            開催日7日前～前々日まで：参加費の80％
            <br />
            開催日の前日以降：参加費の100％
            <br />
          </StepText>
        </StepSection>
      )}
      <FormButtonWrapper>
        <Button
          id="confirm-button"
          type="primary"
          disabled={!pageState.isRequiredFieldsFilled()}
          onClick={() => pageState.goToConfirmation()}
        >
          確認する
        </Button>
      </FormButtonWrapper>
      {pageState.processing && <GlobalLoader />}
    </Step>
  );
});
